<h2>
	{{ "review and submit" | i18next: { format: "capitalize" } }}
	<span
		class="validation-error"
		*ngIf="anyStepHasErrors()"
	>
		({{ "missing required input" | i18next }})
	</span>
</h2>

<div class="container">
	<div
		class="no-steps-configured"
		*ngIf="stepsWithElements.length === 0"
	>
		{{ "at least one duty must be configured" | i18next }}
	</div>

	<div
		class="step"
		*ngFor="let step of stepsWithElements"
	>
		<div class="step-label">
			{{ "step summary" | i18next: { step: (step.stepLabel | i18next), format: "capitalize" } }}
		</div>
		<div
			class="validated-element"
			*ngFor="let validatedElement of step.validatedElements"
		>
			<span [ngClass]="{ 'validation-error': validatedElement.error }">
				{{ validatedElement.label | i18next: { format: "capitalize" } }}
			</span>
			: {{ validatedElement.value }}
			<div
				*ngIf="validatedElement.extraHtml"
				[innerHTML]="validatedElement.extraHtml(sanitizer)"
			></div>
		</div>
	</div>
</div>

<!-- Separator -->
<div class="separator"></div>

<!-- New copied controls -->
<form [formGroup]="form">
	<div class="form-group">
		<div class="rule-name-label">
			{{ "rule name" | i18next: { format: "capitalize" } }}:
			<span class="required">*</span>
		</div>

		<app-missing-input [show]="showNameExistsError || ruleName?.errors?.['required']">
			<input
        cdkFocusInitial
				class="input want-error-border"
				formControlName="ruleName"
				[placeholder]="'rule name' | i18next: { format: 'capitalize' }"
				maxlength="25"
				[matTooltip]="'max length' | i18next: { max: 25 }"
				[attr.aria-label]="'rule name' | i18next: { format: 'capitalize' }"
			/>
		</app-missing-input>
		<div
			class="error-message"
			[style]="'visibility:' + (showNameExistsError ? 'visible' : 'hidden')"
		>
			{{ "this rule name already exists" | i18next }}
		</div>
	</div>

	<div class="vspace-16px"></div>

	<div class="form-group">
		<div
			class="validation-error" id="exclude-zone-warning"
			*ngIf="hasDupeZones"
		>{{ "excluded zones overlap duty zones" | i18next }}</div>
    <button class="mat-button" id="exclude-zone-button" (click)="openZoneSelector()" type="button" tabindex="0">
			{{ title }}
			<mat-icon>arrow_drop_down</mat-icon>
		</button>

	</div>
</form>
